import MGEGAMEActions from './MGEGAMEActions'

export default class MGLIVEActions extends MGEGAMEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'LIVE',
      gameCode: 'MG-LIVE-050',
      platform: 'MG',
    }

    this.gameName = 'Playboy balckjack'
    this.roundIdPrefix = 'AIBQAAQALJWLO2IA'
  }
}
